/**
 * Shared FireCMS permissions for content collections.
 */
export const editorOrAdminPermissions = ({
  authController,
}: {
  authController: { user?: { roles?: Array<{ id?: string; isAdmin?: boolean }> } | null };
}) => {
  const roles = authController.user?.roles ?? [];
  const hasAccess = roles.some(
    (r) => r.id === "editor" || r.id === "admin" || r.isAdmin
  );
  return {
    read: hasAccess,
    edit: hasAccess,
    create: hasAccess,
    delete: hasAccess,
  };
};
